"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _base = require("@atlaskit/icon/base");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Issue24Icon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm0 8.009v7.982C3 17.098 3.893 18 4.995 18h14.01C20.107 18 21 17.1 21 15.991V8.01A2.004 2.004 0 0019.005 6H4.995C3.893 6 3 6.9 3 8.009zm11.293 1.284a1 1 0 011.414 1.414l-3.5 3.5a1 1 0 01-1.415-.001l-1.97-1.978a1 1 0 111.416-1.411l1.263 1.267 2.792-2.791zM5 15.99c0 .007 14.005.009 14.005.009C18.999 16 19 8.009 19 8.009 19 8.002 4.995 8 4.995 8 5.001 8 5 15.991 5 15.991z"/></svg>`
}, props, {
  size: "medium"
}));

Issue24Icon.displayName = 'Issue24Icon';
var _default = Issue24Icon;
exports.default = _default;